import GuestI from '../interfaces/Guest';
import AllAccessGuestI from '../interfaces/AllAccessGuest';
import { GuestFilters } from '../interfaces/Filters';
import { useEffect, useState } from 'react';
import getFilteredGuests from '../functions/getFilteredGuests';

const useFilteredGuests = (
    guests: GuestI[] | AllAccessGuestI[],
    filters: GuestFilters
) => {
    const [filteredGuests, setFilteredGuests] = useState<GuestI[]>([]);

    useEffect(() => {
        setFilteredGuests(getFilteredGuests(guests, filters));
    }, [guests, filters]);

    return { filteredGuests, setFilteredGuests };
};

export default useFilteredGuests;
